<template>
  <div id="app">
    <router-view class="glCon" :key="route.fullPath" />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
const route = useRoute();
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  font-family: "myInter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* background-color: #0E0E0F; */
  background-color: var(--colorBg);
  color: var(--colorText);

  /* background-color: var(--colorApp); */
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  /* app主色调（使用方法：var(--colorApp)） */
  --colorApp: #457ff7;

  /* 页面背景色 */
  --colorBg: white;
  /* 字体默认色 */
  --colorText: #36477c;

  /* header height */
  --dimHeader: 72px;
  --dimCon: 16.7vw;
}

/* html默认body有个8的margin，这里去掉 */
body {
  margin: 0;
}

div {
  /* font-size: var(--dimText); */
  /* color: var(--colorText); */
  white-space: pre-wrap;
}

img {
  object-fit: contain;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition-delay: 99999s;
  -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
}

input {
  border: none;
  outline: none;
}

input:focus {
  border-width: 0;
}

input,
select,
option,
textarea {
  /* border: none;
  padding: 0;
  outline: none;
  overflow: hidden;
  font-size: var(--dimText); */
}

::-webkit-scrollbar {
  width: 4px;
  height: 0;
  background: transparent;
}

::-webkit-scrollbar-button {
  display: none;
}

::-webkit-scrollbar-track {
  display: none;
}

::-webkit-scrollbar-thumb {
  background: #777782;
  border-radius: 10px;
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 1.5rem;
  /* margin: 6px var(--dimApp); */
  border-radius: 8px;
  background-color: var(--colorApp);
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  /* font-family: "myBold"; */
  font-size: 16px;
  color: white;
  cursor: pointer;
}

button:hover {
  opacity: 0.9;
}

.glCon {
  /* min-height: 100vh; */
  /* height: 100vh; */
  display: flex;
  flex: 1;
  flex-direction: column;
  box-sizing: border-box;
  /* background-color: var(--colorBg); */
}

/* flex布局 */
.glFlex {
  flex: 1;
}

.glBold {
  font-family: "myBold";
}

.glContent {
  flex: 1;
  padding: 0 var(--dimApp);
}

.glRowCenter {
  display: flex;
  align-items: center;
}

.glLeftFlex {
  flex: 1;
  margin-right: var(--dimApp);
}

.glLineCon {
  background-color: white;
  padding: 0 var(--dimApp);
}

.glSepLine {
  height: 1px;
  background-color: var(--colorSep);
}

.glWhiteBg {
  background-color: white;
}

.glPd {
  padding: var(--dimText);
}

.glScroll {
  flex: 1;
  overflow: scroll;
}

.glMyBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: var(--colorApp);
  color: white;
  box-sizing: border-box;
  cursor: pointer;
  font-family: 'myBold';
  font-size: 16px;

  padding: 14px 30px;
  margin: 6px var(--dimApp);
}

/* 点击透明 */
.glMyBtn:hover {
  opacity: 0.9;
}

.glMyBtnDis {
  background-color: #d0d0d0;
  cursor: unset;
}

.glMyBtnDis:hover {
  opacity: 1;
  cursor: not-allowed;
}

.glMbBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 30px;
  margin: 6px var(--dimApp);
  border-radius: 8px;
  background-color: var(--colorApp);
  color: white;
  box-sizing: border-box;
  cursor: pointer;
}

/* 点击透明 */
.glMbBtn:active {
  opacity: 0.8;
}

/*  下三角块 */
.glTriangleDown {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid var(--colorText);
}

/* 上三角块 */
.gl-triangle-up {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 8px solid var(--colorText);
}

.glPop {
  position: absolute;
  background-color: var(--colorMask);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.glPopCon {
  margin: var(--dimApp);
  /* padding: var(--dimApp); */
  background-color: white;
  border-radius: 8px;
}

.glPopBtn {
  border-top: 1px solid var(--colorApp);
  padding: var(--dimText);
  text-align: center;
}

.glAniBtm {
  position: relative;
  animation: myAniBtm 2s reverse linear both;
}

@keyframes myAniBtm {
  from {
    top: 0;
  }

  to {
    top: 100%;
  }
}

/* 文本单行显示，尾部省略 */
.glSingleTxt {
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 标题 */
.glTitle {
  align-self: center;
  margin-top: var(--dimAppTop);
  font-size: var(--dimTitle);
  font-weight: bold;
}

.test {
  background-color: red;
}

.linkTxt {
  color: var(--colorApp);
  cursor: pointer;
}

.linkTxt:active {
  opacity: 0.6;
}

.glHide {
  opacity: 0;
}

.glShow {
  opacity: 1;
}

#ap .head {
  justify-content: center;
}

#ap .headSp {
  width: 40px;
}

.el-loading-spinner .path {
  stroke: var(--colorApp);
}

.glShowAni {
  animation: myShow 2s;
  overflow: hidden;
  white-space: nowrap;
}

.glHideAni {
  animation: myHide 2s;
  overflow: hidden;
  white-space: nowrap;
}

@keyframes myShow {
  0% {
    max-width: 0;
  }

  100% {
    max-width: 100%;
  }
}

@keyframes myHide {
  0% {
    max-width: 100%;
  }

  100% {
    max-width: 0;
  }
}

.glShwoHt {
  animation: myShowH 2s;
  overflow: hidden;
  white-space: nowrap;
  align-self: flex-start;
}

.glShwoHtRv {
  animation: myShowH 2s linear reverse;
  overflow: hidden;
  white-space: nowrap;
  align-self: flex-end;
}

@keyframes myShowH {
  0% {
    max-height: 0;
  }

  100% {
    max-height: 100%;
  }
}

.glFade {
  animation: myFade 2s linear;
}

.glFade1 {
  animation: myFade 1s linear;
}

.glFade5 {
  animation: myFade 0.5s linear;
}

.glFade3 {
  animation: myFade 0.3s linear;
}

@keyframes myFade {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}

@keyframes leftRight {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }

  /* 50% {
    opacity: 0.5;
    transform: translateX(-50%);
  }
  33% {
    transform: translateX(-100px);
  }
  66% {
    transform: translateX(100px);
  } */
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes rightLeft {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }

  /* 50% {
    opacity: 0.5;
    transform: translateX(50%);
  } */
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.glB2t {
  animation: topBot 2s;
}

@keyframes topBot {
  0% {
    transform: translateY(-100%);
  }

  /* 50% {
    transform: translateY(-50%);
  } */
  100% {
    transform: translateY(0);
  }
}
</style>
